
import { connect } from "react-redux";
import {appIsLoading, getConfig} from "../../app/actions";
import { SA_UserPortfolios } from "./sa-user-portfolios";
import { navigatePath } from "../../nav/actions";
import {loadPortfolio} from "../../superadmin/portfolio-reducer";
import {
  loadQueueItems,
  loadUserQueueItems,
  createUserRebalance,
  setUserRebalance
} from "../../superadmin/notification-reducer";
import {loadIRRScores} from "../../superadmin/irr-reducer";
import {setOnboardingData} from "../../onboarding/actions";
import {tdaUpdate} from "../../tda/actions";
import {dwollaUpdate} from "../../payment/actions";
import {LoadAllUsers} from "./reducer";

const mapDispatchToProps = dispatch => {
  return {
    getConfig: () => dispatch(getConfig()),
    navigatePath: (path, args) => dispatch(navigatePath(path, args)),
    loadQueueItems: (queue_items) => dispatch(loadQueueItems(queue_items)),
    loadIRRScores: () => dispatch(loadIRRScores()),
    loadPortfolio: (username, index) => dispatch(loadPortfolio(username, index)),
    appIsLoading: loading => dispatch(appIsLoading(loading)),
    setOnboardingData: (onboarding, index, username) => dispatch(setOnboardingData(onboarding, index, username)),
    tdaUpdate: (data, index, username) => dispatch(tdaUpdate(data, index, username)),
    dwollaUpdate: (dwolla, index, username) => dispatch(dwollaUpdate(dwolla, index, username)),
    loadUserQueueItems: (username, index, queue_type) => dispatch(
      loadUserQueueItems(username, index, queue_type)),
    createUserRebalance: (
      username, index, current_risk, new_risk, op,
      category_allocation, security_allocation, trade_orders, portfolio_usd) => dispatch(
      createUserRebalance(username, index, current_risk, new_risk, op,
        category_allocation, security_allocation, trade_orders, portfolio_usd)),
    loadAllUsers: (wlf_id, parent_component, component) => dispatch(LoadAllUsers(wlf_id, parent_component, component)),
    setUserRebalance: (username, index, queue_item, category_to_etf, etf_to_category) => dispatch(
      setUserRebalance(username, index, queue_item, category_to_etf, etf_to_category)),
  }
};

const mapStatetoProps = state => {
  return {
    sa_aum: state.app.wlf.CA_AUM,
    token: state.user.token,
    client: state.client,
    wlfs: state.wlf,
    notification: state.notification,
    portfolio: state.portfolio,
    irr: state.irr,
    config: state.app.config,
    app: state.app,
    users: state.adminUserDashboard,
  }
};

export default connect(mapStatetoProps, mapDispatchToProps)(SA_UserPortfolios);
